// import plotInfo from "./components/plotInfo.vue";
// import temperatureMonitoring from "./components/temperatureMonitoring.vue";
// import inputUsage from "./components/inputUsage.vue";
// import farmManagement from "./components/farmManagement.vue";
// import videoMonitoring from "./components/videoMonitoring.vue";
// import soilMoistureContent from "./components/soilMoistureContent.vue";
export default {
  name: "plotDialog",
  data() {
    return {
      dialogVisible: false,
      plotId: "",
      // 设备编号
      number: ""
    };
  },
  components: {
    // plotInfo,
    // temperatureMonitoring,
    // inputUsage,
    // farmManagement,
    // videoMonitoring
  },
  methods: {
    // 获取地块详情
    async getPlotInfo(id) {
      let {
        code,
        data
      } = await this.$api.getPlotInfo(id);
      console.log(data, "地块信息");
      if (code == "200") {
        this.number = data.greenhouseVoList[0].number;
        window.localStorage.setItem("plotInfo", JSON.stringify(data));
      }
    },
    // 关闭dialog
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.videos.destroyed();
    },
    // 打开时触发
    openChange() {
      console.log('打开地块弹框触发');
      // this.getPlotInfo(this.plotId);

      // this.$refs.temperatureMonitoring.initChart();
      // this.$refs.inputUsage.initChart();
    },

    // 关闭弹窗前触发
    handleClose(done) {
      console.log('关闭');
      this.$refs.videos.destroyed();
      done();
    },
    // 打开弹窗
    async open(number) {
      this.plotId = number;
      await this.getPlotInfo(this.plotId);
      this.dialogVisible = true;
      setTimeout(() => {}, 1000);
    },
    lookDetail() {
      this.$refs.greenhouseDialog.open(this.number, this.plotId);
    },
    lookDetail2() {
      this.$refs.soilDialog.open(this.number);
    }
  }
};